/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listenToAddZone = /* GraphQL */ `
  subscription ListenToAddZone($customerId: String) {
    listenToAddZone(customerId: $customerId) {
      alertData
      deviceId
      exclusions
      id
      inspectTime
      keyFrame
      name
      nodeId
      pan
      serviceId
      shouldNotify
      signedUrlKeyFrame
      status
      threshold {
        id
        name
        value
      }
      tilt
      zoom
    }
  }
`;
export const listenToDeleteZone = /* GraphQL */ `
  subscription ListenToDeleteZone($id: String) {
    listenToDeleteZone(id: $id) {
      alertData
      deviceId
      exclusions
      id
      inspectTime
      keyFrame
      name
      nodeId
      pan
      serviceId
      shouldNotify
      signedUrlKeyFrame
      status
      threshold {
        id
        name
        value
      }
      tilt
      zoom
    }
  }
`;
export const listenToDeviceData = /* GraphQL */ `
  subscription ListenToDeviceData($customerId: String!) {
    listenToDeviceData(customerId: $customerId) {
      cameraIpAddress
      customerId
      deviceData {
        hasPanTilt
        hasRecordVideo
        hasZoom
        keyFrame
        pan
        panTiltIP
        protocol
        recentFrame
        rtspHost
        signedUrlKeyFrame
        signedUrlRecentFrame
        sourceVideo
        tilt
        zoom
      }
      healthData {
        isOnline
        lastAlive
        totalDowntime
        totalUptime
        uptimeDate
        uptimePercent
      }
      id
      locationId
      locationName
      makeModelId
      name
      nodeId
      nodeName
      status
    }
  }
`;
export const listenToDeviceHealthData = /* GraphQL */ `
  subscription ListenToDeviceHealthData($customerId: String!) {
    listenToDeviceHealthData(customerId: $customerId) {
      cameraIpAddress
      customerId
      deviceData {
        hasPanTilt
        hasRecordVideo
        hasZoom
        keyFrame
        pan
        panTiltIP
        protocol
        recentFrame
        rtspHost
        signedUrlKeyFrame
        signedUrlRecentFrame
        sourceVideo
        tilt
        zoom
      }
      healthData {
        isOnline
        lastAlive
        totalDowntime
        totalUptime
        uptimeDate
        uptimePercent
      }
      id
      locationId
      locationName
      makeModelId
      name
      nodeId
      nodeName
      status
    }
  }
`;
export const listenToEdgeClientMessage = /* GraphQL */ `
  subscription ListenToEdgeClientMessage($id: String) {
    listenToEdgeClientMessage(id: $id) {
      id
      payload
      payloadType
      statusCode
      timestamp
      topic
    }
  }
`;
export const listenToHumanValidationEvents = /* GraphQL */ `
  subscription ListenToHumanValidationEvents {
    listenToHumanValidationEvents {
      audited_by
      auditorsExplanation
      customerId
      data
      eventTime
      explanation
      id
      locationId
      nodeId
      serviceId
      transitionInfo
      validated_by
      validationState
    }
  }
`;
export const listenToNodeFiles = /* GraphQL */ `
  subscription ListenToNodeFiles($nodeId: String!) {
    listenToNodeFiles(nodeId: $nodeId) {
      downloadURL
      file
      internalNodeId
    }
  }
`;
export const listenToNodeMessages = /* GraphQL */ `
  subscription ListenToNodeMessages($nodeId: String!) {
    listenToNodeMessages(nodeId: $nodeId) {
      internalNodeId
      message
    }
  }
`;
export const listenToNodeOnlineStatus = /* GraphQL */ `
  subscription ListenToNodeOnlineStatus($customerId: String!) {
    listenToNodeOnlineStatus(customerId: $customerId) {
      customerId
      deviceData
      devices {
        cameraIpAddress
        customerId
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          pan
          panTiltIP
          protocol
          recentFrame
          rtspHost
          signedUrlKeyFrame
          signedUrlRecentFrame
          sourceVideo
          tilt
          zoom
        }
        healthData {
          isOnline
          lastAlive
          totalDowntime
          totalUptime
          uptimeDate
          uptimePercent
        }
        id
        locationId
        locationName
        makeModelId
        name
        nodeId
        nodeName
        status
      }
      id
      isOnline
      level
      locationId
      nodeIP
      nodeId
      nodeName
      onboardCommand
      referenceId
      serviceData
      tags {
        id
        tagName
      }
    }
  }
`;
export const listenToServiceHealthData = /* GraphQL */ `
  subscription ListenToServiceHealthData($customerId: String!) {
    listenToServiceHealthData(customerId: $customerId) {
      configuration
      customerId
      deviceId
      healthData
      id
      isRunning
      locationId
      nodeId
      serviceType
    }
  }
`;
export const listenToUpdateZone = /* GraphQL */ `
  subscription ListenToUpdateZone($id: String) {
    listenToUpdateZone(id: $id) {
      alertData
      deviceId
      exclusions
      id
      inspectTime
      keyFrame
      name
      nodeId
      pan
      serviceId
      shouldNotify
      signedUrlKeyFrame
      status
      threshold {
        id
        name
        value
      }
      tilt
      zoom
    }
  }
`;
